import { cn } from '@/utils/tailwind.helper'
import dayjs, { formatStorage } from '@wox/dayjs'
import { TimePicker, TimePickerProps } from 'antd'

export interface KBTimePickerProps extends TimePickerProps {}

export function KBTimePicker(props: KBTimePickerProps) {
  const { size = 'large', className, value, ...others } = props
  const timeFormat = formatStorage.get()?.timeFormat || 24
  return (
    <TimePicker
      size={size}
      value={value ? dayjs(value) : null}
      data-testid="time-picker"
      inputReadOnly // Prevent keyboard input
      format={timeFormat === 24 ? 'HH:mm' : 'hh:mm A'}
      {...others}
      className={cn(size === 'large' && 'tw-h-9', 'kb-time-picker', className)}
    />
  )
}

KBTimePicker.RangePicker = TimePicker.RangePicker
